export const DOMAIN = 'openinsight.app'
